// extracted by mini-css-extract-plugin
module.exports = {"linkedAccountCategory":"LinkedAccountCategory__linkedAccountCategory__EAxYJ","logoCategory":"LinkedAccountCategory__logoCategory__f3CkR"};